import { gql, useQuery } from '@apollo/client';

import { NexoyaQuery, NexoyaQueryPortfolioArgs } from '../../types/types';
import { useTeam } from '../../context/TeamProvider';

import {
  PORTFOLIO_2_CONTENT,
  PORTFOLIO_2_DATES_FRAGMENT,
  PORTFOLIO_2_DEFAULT_OPTIMIZATION_TARGET,
  PORTFOLIO_2_META_FRAGMENT,
  PORTFOLIO_FUNNEL_STEP,
} from './fragments';
import dayjs from 'dayjs';

const PORTFOLIO_QUERY = gql`
  query Portfolio($portfolioId: Int!, $teamId: Int!, $dateFrom: DateTime, $dateTo: DateTime) {
    portfolio(portfolioId: $portfolioId, teamId: $teamId, dateFrom: $dateFrom, dateTo: $dateTo) {
      ...portfolioMeta
      ...portfolioDates
      ...portfolioContent
      ...portfolioFunnelStep
      ...portfolioDefaultOptimizationTarget
      optimizationRiskLevel
      optimizationType
    }
  }
  ${PORTFOLIO_2_META_FRAGMENT}
  ${PORTFOLIO_2_DATES_FRAGMENT}
  ${PORTFOLIO_2_CONTENT}
  ${PORTFOLIO_FUNNEL_STEP}
  ${PORTFOLIO_2_DEFAULT_OPTIMIZATION_TARGET}
`;
type Options = {
  portfolioId: number;
  skip?: boolean;
  dateFrom?: Date;
  dateTo?: Date | string;
};

function usePortfolioQuery({ portfolioId, dateFrom, dateTo }: Options) {
  const { teamId } = useTeam();

  const query = useQuery<Pick<NexoyaQuery, 'portfolio'>, NexoyaQueryPortfolioArgs>(PORTFOLIO_QUERY, {
    notifyOnNetworkStatusChange: true,
    variables: {
      teamId,
      portfolioId,
      dateFrom: dayjs(dateFrom)?.utc().toDate(),
      dateTo: dayjs(dateTo)?.utc().toDate(),
    },
    skip: !portfolioId,
  });
  return query;
}

export { usePortfolioQuery };
